import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { Header, Input, InputOnChangeData, Table } from 'semantic-ui-react';
import StandardizedLabelsRepo from '../../../../../utils/repository/standardizedLabelsRepo/standardizedLabelsRepo';
import { TableModelType, getTableModel } from './utils';
import Loader from '../../../../../components/loader';
import { Link } from 'react-router-dom';
import { RESPONSE_STATUS } from '../../../../../constnats/general';
import Alert from '../../../../../utils/alert';

const SEARCH_DEBOUNCE_TIME = 200; // time is in ms

const StandardizedLabelRelations = () => {
    const [tableModel, setTableModel] = useState<TableModelType>([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        setLoading(true);
        StandardizedLabelsRepo.getRelations(
            (res) => {
                if (res.status === RESPONSE_STATUS.SUCCESS) {
                    setTableModel(getTableModel(res.data));
                } else {
                    Alert.warn(res.message);
                }
                setLoading(false);
            },
            (error) => {
                Alert.warn(JSON.stringify(error));
                setLoading(false);
            },
        );
    }, []);

    const handleSearchChange = useCallback(
        _.debounce(
            (__: React.ChangeEvent<HTMLInputElement>, { value }: InputOnChangeData) => setSearchTerm(value),
            SEARCH_DEBOUNCE_TIME,
        ),
        [],
    );

    return (
        <>
            <Header textAlign="center" as="h3">
                Standardized Label Relations
            </Header>
            {loading ? (
                <Loader />
            ) : (
                <>
                    <Input icon="search" placeholder="Search by Name" onChange={handleSearchChange} />
                    <Table celled striped structured>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Label Name</Table.HeaderCell>
                                <Table.HeaderCell>Company Name</Table.HeaderCell>
                                <Table.HeaderCell>Schema Name</Table.HeaderCell>
                                <Table.HeaderCell>Field Name</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {tableModel
                                .filter((standardizedLabel) =>
                                    standardizedLabel.standardizedLabelName.toLowerCase().includes(searchTerm.toLowerCase()),
                                )
                                .map((standardizedLabel) => {
                                    const companiesIds = Object.keys(standardizedLabel.companiesMap);

                                    return companiesIds.map((companyId, companyIdIndex) => {
                                        const company = standardizedLabel.companiesMap[companyId];
                                        const schemaIds = Object.keys(company.schemasMap);

                                        return schemaIds.map((schemaId, schemaIdIndex) => {
                                            const schema = company.schemasMap[schemaId];
                                            const descriptors = schema.descriptors;
                                            const schemaRowSpan = descriptors.length;

                                            return descriptors.map((descriptor, descriptorIndex) => {
                                                const isDuplicate = descriptors.length >= 2;
                                                return (
                                                    <Table.Row key={descriptor.descriptorLabel + descriptorIndex} error={isDuplicate}>
                                                        {companyIdIndex === 0 &&
                                                        schemaIdIndex === 0 &&
                                                        descriptorIndex === 0 ? (
                                                            <Table.Cell
                                                                verticalAlign="top"
                                                                rowSpan={standardizedLabel.descriptorsCount}
                                                            >
                                                                {standardizedLabel.standardizedLabelName}
                                                            </Table.Cell>
                                                        ) : null}
                                                        {schemaIdIndex === 0 && descriptorIndex === 0 ? (
                                                            <Table.Cell
                                                                verticalAlign="top"
                                                                rowSpan={company.descriptorsCount}
                                                            >
                                                                <Link
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    to={`/admin/companies/${company.companyId}`}
                                                                >
                                                                    {company.companyName}
                                                                </Link>
                                                            </Table.Cell>
                                                        ) : null}
                                                        {descriptorIndex === 0 ? (
                                                            <Table.Cell verticalAlign="top" rowSpan={schemaRowSpan}>
                                                                {schema.schemaName}
                                                            </Table.Cell>
                                                        ) : null}
                                                        <Table.Cell>{descriptor.descriptorLabel}</Table.Cell>
                                                    </Table.Row>
                                                );
                                            });
                                        });
                                    });
                                })}
                        </Table.Body>
                    </Table>
                </>
            )}
        </>
    );
};

export default StandardizedLabelRelations;
